const orderTypes = {
	SETTLEMENT: 'settlement'
};

module.exports = orderTypes;
